export function getCurrentAuthority() {
  return localStorage.getItem("xnserve-authority");
} //获取权限
export function check(authority) {
  const current = getCurrentAuthority().split(",");
  return current.some(item => authority.includes(item));
}

export function getCurrentAuthorityType() {
  return localStorage.getItem("xnserve-authority-type");
} //获取类型权限

export function checkType(type) {
  const current = getCurrentAuthorityType();
  if (type) {
    return type.includes(current);
  }
}
export function isLogin() {
  const current = getCurrentAuthority().split(",");
  return current && current[0] !== "";
}
const url = "https://api.xnserve.com/"; //正式环境
// const url = "https://apitest.xnserve.com/"; //测试环境
// eslint-disable-next-line prettier/prettier
const user = "user/";
const trade = "trade/";
const resume = "resume/";
const message = "message/";
const map = "map/";
const customer = "customer/";
const logistics = "logistics/";
const retail = "retail/";
const equipment = "equipment/";
const clean = "clean/";
const recruitment = "recruitment/";
const index = "index/";
const finance = "finance/";
const people = "people/";
export default {
  url,
  user,
  trade,
  resume,
  message,
  map,
  customer,
  logistics,
  retail,
  equipment,
  clean,
  recruitment,
  index,
  finance,
  people
};
